document.addEventListener('DOMContentLoaded', () => {
  let loading = false;
  let currentPage = 1;

  async function loadMoreProducts() {
    if (loading) return;

    const grid = document.querySelector('#product-grid');
    if (!grid) return;

    const loadTrigger = document.getElementById('load-more');
    if (!loadTrigger) return;

    const rect = loadTrigger.getBoundingClientRect();

    if (rect.top > window.innerHeight + 1200) return;

    loading = true;
    currentPage++;

    const nextUrl = new URL(window.location.href);
    nextUrl.searchParams.set('page', currentPage);

    try {
      const response = await fetch(nextUrl.toString());
      const html = await response.text();

      const doc = new DOMParser().parseFromString(html, 'text/html');

      const newItems = doc.querySelectorAll('#product-grid > li');

      if (newItems.length === 0) {
        loadTrigger.remove();
        window.removeEventListener('scroll', onScroll);
        return;
      }

      newItems.forEach(item => grid.appendChild(item));

      loading = false;

    } catch (e) {
      console.error(e);
      loading = false;
    }
  }

  function onScroll() {
    loadMoreProducts();
  }

  window.addEventListener('scroll', onScroll);
});